import ActionButtons from './component';
import { ActionButtonsProps } from './types';

export default ActionButtons;
export type { ActionButtonsProps };
